/* eslint-disable no-undef, camelcase */
// Resolve copied assets (e.g. symbols) relative to the runtime asset base. For the web-component
// build `__webpack_public_path__` is the bundle's serving origin (set in index.web-component.js);
// for other targets it is empty, so fall back to a root-relative path as before.
export default path => {
  const base =
    typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__
      ? __webpack_public_path__
      : '/';
  return `${base}assets/${path}`;
};
/* eslint-enable no-undef, camelcase */
